export default __webpack_public_path__ + "static/media/loginMeiHao.3415338b.png";